module.exports = __webpack_public_path__ + "static/img/withdrawal-process.033616d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/withdrawal-process.png
// module id = VXQm
// module chunks = 216